import { MetricsSkeleton } from "components/PortalLoading";
import React, { useState } from "react";
import useCheckIfUserIsSubscribed from "api/SubscriptionsResource/useCheckIfUserIsSubscribed";
import AddSeatsModal from "components/AddSeatsModal";
import { FiPlus } from "react-icons/fi";
import { ReportPanel } from "components/PortalDashboard";

import useAuthStore from "store/authStore";
import { Role } from "utils/server-constants/roles";
import { Link } from "react-router-dom";

const SubscriptionSeatsCard = () => {
	const [showAddSeatsModal, setShowAddSeatsModal] = useState(false);
	const hasRoles = useAuthStore((state) => state.hasRoles);

	const { data: isSubscribed, isLoading } = useCheckIfUserIsSubscribed();

	const currentSubscription = isSubscribed?.data || null;
	const isInstitutional = currentSubscription?.category === "institution";
	const canAddSeats = isInstitutional && hasRoles([Role.Institution, Role.Educator]);
	const seatsPurchased = currentSubscription?.seats_purchased || currentSubscription?.number_of_seats || 1;
	const maxAllocationsPerSeat =
		currentSubscription?.max_allocations_per_seat || currentSubscription?.max_number_of_books || 0;

	if (isLoading) {
		return <MetricsSkeleton label="Loading subscription seat capacity…" labels={["Current seats", "Allocations / seat", "Plan"]} />;
	}

	// Only show this card when user can actually add seats
	if (!canAddSeats) {
		return null;
	}

	return (
		<>

            <ReportPanel className="portal-seat-card" title="Institution seat capacity" description="Manage access to your institution’s subscription.">
                <div className="portal-seat-layout">
                    <div>
                        <dl className="portal-seat-stats">
                            <div><dt>Current seats</dt><dd className="text-3xl font-bold">{seatsPurchased}</dd></div>
                            <div><dt>Allocations / seat</dt><dd className="text-xl">{maxAllocationsPerSeat}</dd></div>
                            <div><dt>Plan</dt><dd className="text-xl">{currentSubscription?.name || "N/A"}</dd></div>
                        </dl>
                        <p className="portal-seat-note">Add seats to share picked books with more students.</p>
                    </div>
                    <div className="portal-seat-actions">
                        <button type="button" onClick={() => setShowAddSeatsModal(true)} className="portal-button"><FiPlus aria-hidden="true" /> Add seats</button>
                        <Link to="/my-account/subscriptions">View subscription details</Link>
                    </div>
                </div>
            </ReportPanel>

			<AddSeatsModal
				visible={showAddSeatsModal}
				onHide={() => setShowAddSeatsModal(false)}
				subscription={currentSubscription}
			/>
		</>
	);
};

export default SubscriptionSeatsCard;
